function showitindetails() {	
    //Hide (Collapse) the toggle containers on load
    $(".itinerary-details-container").hide(); 
    //Switch the "Open" and "Close" state per click
    $("h4.heading").toggle(function(){    	
        $(this).addClass("active");
        }, function () {
        $(this).removeClass("active");
    });
    
    //Slide up and down on click
    $("h4.heading").click(function(){
        $(this).next(".itinerary-details-container").slideToggle("fast");
        $(".itinerary-details-container div:last-child").addClass('border-none');
    });

    //Accessibility tab index click event.
  $("h4.heading").keypress(function(e){
    if( e.keyCode === 13 || e.keyCode === 32 ){
      e.preventDefault();
      $(this).trigger('click');
    }   
  });

        
	$('.show-hide').click(function() {  	
		$(".itinerary-details-container").slideToggle('fast',function(){    
			  if ($(this).is(':hidden')) {
				$(".show-hide").html('<a href="javascript:void(0)">Show All Itinerary Details<\/a>');
				$(".itinerary-details-container").hide();
				$("h4.heading").removeClass("active");
			  }else {
				$(".show-hide").html('<a href="javascript:void(0)">Hide All Itinerary Details<\/a>');
				$(".itinerary-details-container").show();
				$(".itinerary-details-container div:last-child").addClass('border-none');
				$("h4.heading").addClass("active");
			  }
			  return false;
		});
	});

    //Larger thumbnail preview  
    var image1=$(".lgImg").attr("src"); 
    $(".thumb1").mouseover(function(){      
      $(".lgImg").attr('src', $(".thumb1").attr("src").replace('/sm','/lg')); 
    });
    $(".thumb1").mouseout(function(){   
       $(".lgImg").attr('src', image1);  
    });
    $(".thumb2").mouseover(function(){      
      $(".lgImg").attr('src', $(".thumb2").attr("src").replace('/sm','/lg')); 
    });
    $(".thumb2").mouseout(function(){   
       $(".lgImg").attr('src', image1);  
    });
    $(".thumb3").mouseover(function(){      
      $(".lgImg").attr('src', $(".thumb3").attr("src").replace('/sm','/lg')); 
    });
    $(".thumb3").mouseout(function(){   
       $(".lgImg").attr('src', image1);  
    });
}
$(document).off('click.shareExc').on('click.shareExc', '#share-excursion', function(e){
	e.preventDefault();
	var exType = $('#share-excursion').data('type');
	var portCode = $('#share-excursion').data('port');	
	var voyage = $('#share-excursion').data('voyage');
	var trade = $('#share-excursion').data('t');
	var pCode = $('#share-excursion').data('tour');
	if(exType == 'L'){
		shareLdxView(portCode, voyage, trade, pCode)
	}else{
		shareShxView(portCode, voyage, trade, pCode);
	}	
});

// $(document).on('click', 'h3#poi-filter', function(){
//             $(".excursion-list").slideToggle(10, function(){
                
//                 if ($(this).is(':hidden')) {
//                     $("h3#poi-filter").parent().parent().css('marginBottom', '20px');
//                     $("h3#poi-filter").html('<a href="javascript:void(0)">Show Points of Interest<\/a>');
//                     $("h3#poi-filter a").removeClass('downArrow').addClass('upArrow').attr('aria-expanded', 'false');
//                 }
//                 else{
//                     $("h3#poi-filter").parent().parent().css('marginBottom', '0');
//                     $("h3#poi-filter").html('<a href="javascript:void(0)">Hide Points of Interest<\/a>');
//                     $("h3#poi-filter a").removeClass('upArrow').addClass('downArrow').attr('aria-expanded', 'true');  
//                 }
//                 return false;
//         });
//     });

// $(document).on('click', 'h3#filter-options', function(e){
// 	$("#flash-filter").slideToggle(10, function(){                
// 		if ($(this).is(':hidden')) {
// 			$("h3#filter-options").html('<a href="javascript:void(0)">Show Filter Options<\/a>');
// 			 $("h3#filter-options a").removeClass('downArrow').addClass('upArrow').attr('aria-expanded', 'false');
// 		}
// 		else{
// 			$("h3#filter-options").html('<a href="javascript:void(0)">Hide Filter Options<\/a>');
// 			$("h3#filter-options a").removeClass('upArrow').addClass('downArrow').attr('aria-expanded', 'true');
			
// 		}
// 		return false;
// 	});
// });

function emp(){}
function close(elemId){
  document.getElementById(elemId).innerHTML= "";
}
function showGridView(ex,vID,portId,prodTourCode) {  
  if(ex==''||ex=='S'){var urls="/excursion/excursionList.do?grid=GRID&exType=S&voyageCode="+vID+"&portid="+portId+"&prodTourCode="+prodTourCode;}  
  if(ex=='L'){ urls="/excursion/landExcursionList.do?grid=GRID&exType=L&voyageCode="+vID+"&portid="+portId+"&prodTourCode="+prodTourCode;}
  $("#white-line").html("<a href=\"javascript:showListView('"+ex+"','"+vID+"','"+portId+"','"+prodTourCode+"');\"><img src=\"/images/share/excursions/three_blue_lines.gif\" width=\"20\" height=\"20\"   alt=\"List View\" /></a> <a href=\"javascript:showListView('"+ex+"','"+vID+"','"+portId+"','"+prodTourCode+"');\">List</a>");
  $("#blue-line").html("<img src=\"/images/share/excursions/four_white_boxes.gif\" width=\"20\" height=\"20\" alt=\"Grid View\" /> Grid ");
  showExList(urls);
}
function showListView(ex,vID,portId,prodTourCode) {  
  if(ex==''||ex=='S'){var urls="/excursion/excursionList.do?grid=&exType=S&voyageCode="+vID+"&portid="+portId+"&prodTourCode="+prodTourCode;}
  if(ex=='L'){ urls="/excursion/landExcursionList.do?grid=&exType=L&voyageCode="+vID+"&portid="+portId+"&prodTourCode="+prodTourCode; }
  $("#white-line").html("<img src=\"/images/share/excursions/three_white_lines.gif\" width=\"20\" height=\"20\" alt=\"List View\" /> List ");
  $("#blue-line").html("<a href=\"javascript:showGridView('"+ex+"','"+vID+"','"+portId+"','"+prodTourCode+"');\"><img src=\"/images/share/excursions/four_blue_boxes.gif\" width=\"20\" height=\"20\" alt=\"Grid View\" /></a> <a href=\"javascript:showGridView('"+ex+"','"+vID+"','"+portId+"','"+prodTourCode+"');\">Grid</a>");  
  showExList(urls);
}
function showFilterList(ctgry,pr,d,s,pID,pDate,vID,tourCode,voyFlag,gTrackValue) {//called from filter
  $('#loading').hide()  // hide it initially
    .ajaxStart(function() {
        $(this).show();
    })
    .ajaxStop(function() {
        $(this).hide();
    });
  if(gTrackValue!=null && gTrackValue!='')pageTracker._trackPageview(gTrackValue);    
  var urls="/excursion/excursionList.do?ctgry="+ctgry+"&pr="+pr+"&d="+d+"&s="+s+"&portid="+pID+"&voyageCode="+vID+"&exType=S"+"&prodTourCode="+tourCode+"&voyFlag="+voyFlag+"&sortOrder=lowtohigh";
  function c(){//callback
	$('#loading').hide();
    exListSuccess();
  }     
  ajaxWthCallback(urls,'contentTab',c,true);
}

function showLdxFilterList(ctgry,pr,d,s,pID,pDate,vID,tourCode,voyFlag,gTrackValue){ 
  $('#loading').hide()  // hide it initially
   .ajaxStart(function() {
        $(this).show();
    })
    .ajaxStop(function() {
        $(this).hide();
    });
  if(gTrackValue!=null && gTrackValue!='')pageTracker._trackPageview(gTrackValue);   
  var urls="/excursion/landExcursionList.do?ctgry="+ctgry+"&pr="+pr+"&d="+d+"&s="+s+"&portid="+pID+"&voyageCode="+vID+"&exType=L"+"&prodTourCode="+tourCode+"&voyFlag="+voyFlag+"&sortOrder=lowtohigh";
  function c(){//callback  
    $('#loading').hide(); 
    exListSuccess();
  }         
  ajaxWthCallback(urls,'contentTab',c,true);    
}
function showExcursionDetails(tcode,vID,bID,portId,exType,prodTourCode) {
      $('#loading').hide();
	  $('.print-share-bottom-panel').hide();
      if(exType=='L') {
          var urls="/excursion/daLdxDetails.do?tourCode="+tcode+"&voyageCode="+vID+"&bID="+bID+"&portid="+portId+"&prodTourCode="+prodTourCode+"&exType=L";
      } else {
          var urls="/excursion/daExDetails.do?tourCode="+tcode+"&voyageCode="+vID+"&bID="+bID+"&portid="+portId+"&prodTourCode="+prodTourCode+"&exType=S";
      }
      function c(){//callback          
          create_tooltip();
          showitindetails();  
		  $("html:not(:animated),body:not(:animated)").animate({ scrollTop: $("#tab-content").offset().top }, 1500); 
      }         
      ajaxWthCallback(urls,'excursion-container',c,true);
}

function loadTabContent(url, divId){
	$('#tabs a').removeClass('active');
	$('#'+divId).addClass('active');
  divId = 'tab-'+divId+'-content';
	ajaxWthCallback(url,divId,c, true);
	function c(){
		$("html:not(:animated),body:not(:animated)").animate({ scrollTop: $("#tab-content").offset().top }, 1500);
		no_excursions_selected();
		var portCode = $('#share-excursion').data('port');	
		/*showFbLike("port_"+portCode,$('#fbUrl').val(),"true"); */  
		loadFiltersOutsideCP(portCode, '', $('#share-excursion').data('voyage'), $('#share-excursion').data('tour'), $('#share-excursion').data('avail'), $('#share-excursion').data('type'));
	}//callback
}
function loadExcursionList(shorexdata,landexData,travelOrder) {
    if(travelOrder=="" ||travelOrder=="A") {    	
        populatePorts(shorexdata,"S");
        populatePorts(landexData,"L");
    } else if(travelOrder=="B") {
        populatePorts(landexData,"L");
        populatePorts(shorexdata,"S");
    }
    $('.anchor-jump').click(function(e) {
        e.preventDefault();
        var divID = $(this).attr('href');
        $('html,body').animate({scrollTop: $(divID).offset().top},1500);
    });
}

function submitPortDropdown(voyageId,portId,tourCode) {  
	var dropdownValue = portId.split('|');			
	var queryString="voyageCode="+voyageId+"&portid="+dropdownValue[0]+"&exType="+dropdownValue[1];
	if(tourCode != null && tourCode.length>0){
		queryString+="&tourCode="+tourCode+"&resType=T";
	}	
    var url = "/excursion/popupPortPOI.do?"+queryString+"&random=" +(Math.random() * Date.parse(new Date()));      
    openLightbox(url); 
}

function populatePorts(data,ind){
    if(typeof data!="undefined"){
        $.each(data,function() { 
          var option = new Option(this.n, this.v+ind);
            var l=document.getElementById("portlst");      
            if($.browser.msie)
                l.add(option);                 
            else                     
                l.add(option, null);
         }); 
    }
}

function submitPort(voyageId,portId,bID,tourCode){  
  var url = "";
  var formattedPortId ='';
  var exType = "";  
  if(null != portId && portId.length >0){   
   formattedPortId = portId.substring(0,portId.length-2);
   exType = portId.substring(portId.length-1);
  }
  if(voyageId.length > 0 ) {
      url = "/excursion/exlistforvoyage.do?portid="+formattedPortId+"&voyageCode="+voyageId+"&bID="+bID+"&exType="+exType;
      if(tourCode.length > 0) {
          url=url+"&resType=T&tourCode="+tourCode;
      }
	  $.ajax({
		type : 'GET',
		url  : url,		
		context: document.body
	  }).done(function(data) {
		$('#tab-exList .exList').remove();
		var $newDiv = $("<div/>").attr({
      "id": "tab-exList-content",
      "class": "exList container clearfix"
    });
		$('#tab-exList').append($newDiv.html(data));
		no_excursions_selected();
		$('#portlst').val(portId);
		/*showFbLike("port_"+formattedPortId,$('#fbUrl').val(),"true"); */  
		loadFiltersOutsideCP(formattedPortId, '', voyageId, tourCode, $('#share-excursion').data('avail'), $('#share-excursion').data('type'));
	  });	  
  } else {
      url = "/excursion/exlistfordestination.do?portid="+formattedPortId+"&exType="+exType;
      if(typeof(document.exListForm.tid)!='undefined') {
          var tradeId = document.exListForm.tid.value;
          if(null != tradeId && tradeId.length >0){
              url = url+"&t="+tradeId;
          }
      }   
      document.exListForm.action = url;
      document.exListForm.submit();
  }
}

function submitOrder(idValue,excursionType, voyageCode, tourCode){
      var url = "";
	  var type="shorex";
      var queryString="sortOrder="+idValue+"&exType="+excursionType+"&voyageCode="+voyageCode;
      if(null != tourCode && tourCode.length > 0){
      	queryString+='&prodTourCode='+tourCode;
		type="landex";
      }      
      if(excursionType=='L'){ 
		url="/excursion/landExcursionList.do?"+queryString; 		
	  }else{
		url="/excursion/excursionList.do?"+queryString;
	  }
	  /*pageTracker._trackPageview('/flash/excursions/'+type+'/ports/filter/sort/'+idValue); */
      showExList(url);
}

function showExList(urls) {
    ajaxWthCallback(urls,'contentTab',exListSuccess,true);    
}
function exListSuccess(){
  create_tooltip();
  excursion_group_toggle();
  // ADA: bump headers up one level for details > shorex iframe
  if (typeof headerFixForIframe === 'function') {
    headerFixForIframe();
  }
  /*listFbLike();*/
}
function openBox(url){	
	$('#ajax-load').load(url + " .lite-popup", function () {
		lightbox_show_hide(); 
	});
}

function printDiv(theDiv){
    var printDiv = $('#' + theDiv).clone();
    printDiv.find('.facebook-like-link').remove();
    
    if(theDiv == 'current-reservations' || theDiv == 'wishlist'){
        var title = printDiv.prev('.panel-header-grey').html();
        printDiv.prepend(title);
        printDiv.find('h3').addClass('.section-heading');
    }
    printDiv.find('#excursion-group').removeAttr('style');
    printDiv.prepend('<div id="print-logo"><img src="/images/share/excursions/princess_print_logo.png" width="259" height="42" alt="" /></div>');
    if($.browser.msie && $.browser.version < 9){
        if(theDiv == 'content'){
            printDiv.find('.excursion').after('<div class="temp-div"> </div>');
            printDiv.find('.panel-header').after('<div class="temp-div"> </div>');
        }
    }
    
    printDiv.jqprint({importCSS:true});
    
    $(function() {
      setInterval(removeIframe, 4000);
    });
}
    
 function removeIframe() { 
    //$('#print-frame').remove();
 }

function loadFlash(voyageid,portid,exType,tourCode,voyFlag) {
    var flashvars;
    if(voyageid!="") {
        flashvars = { 
                pID: portid,
                uPath: "/find/excursion",
                voyageid:voyageid,
                tourCode:tourCode,
                voyFlag:voyFlag
              }; 
    } else {
         flashvars = { 
                pID: portid,
                uPath: "/find/excursion",
                voyFlag:voyFlag
              };        
    }
    var params = { 
            loop: "false",
            menu: "false",
            quality: "high",
            allowscriptaccess: "sameDomain",
            wmode: "transparent"
          }; 
    var attributes = { 
            id: "filter1", 
            name: "filter",
            wmode: "transparent"  
          };
    if(exType=="L") {
        swfobject.embedSWF("/flash/global/cp/excursions/landx_filters.swf", "filter", "958", "184.5", "9.0.0", false, flashvars, params, attributes);
    } else {
        swfobject.embedSWF("/flash/global/cp/excursions/shorex_filters.swf", "filter", "958", "184.5", "9.0.0", false, flashvars, params, attributes);
    }

}

function shareShxView(port, voyage, trade, pCode){
    var frm=eval("document.cruiseDetailForm");  
    var url= '/excursion/shareShx.do?portid='+port+'&voyageCode='+voyage+'&t='+trade+'&tourCode='+pCode+'&'+$("input[name=sharedEx]").serialize();   
    if(null == frm || frm == 'undefined'){    
        frm=eval("document.exListForm");             
    }   
    var sharedExLen=$("input[name=sharedEx]:checked").length;
    if(sharedExLen > 0 && sharedExLen <=5){     	  
        frm.action=url;
        frm.submit();
    }
}

function shareLdxView(port, voyage, trade, pCode){ 
    var frm=eval("document.cruiseDetailForm");   
	var url= '/excursion/shareLdx.do?portid='+port+'&voyageCode='+voyage+'&t='+trade+'&tourCode='+pCode+'&'+$("input[name=sharedEx]").serialize();  
    if(null == frm || frm == 'undefined'){
       frm=eval("document.exListForm");      
    }     
    var sharedExLen=$("input[name=sharedEx]:checked").length;
    if(sharedExLen > 0 && sharedExLen <=5){               
        frm.action=url;
        frm.submit();
    }
}

function ajaxCall(urls,elemId){
  function c(){//callback
 }
  ajaxWthCallback(urls,elemId,c,false);
} 
     
function ajaxWthCallback(urls,elemId,func,isglobal){
  $.ajax({ 
    type: "POST", 
    url:urls, 
    dataType:"html",  
    global:isglobal,
    success:function(s){      
	  //if ($('#tabs').length > 0) {
		//$('html,body').stop().animate({scrollTop: ($('#tabs').offset().top)-20 }, 1500);
	  //}
	  $("#"+elemId).html(s); 
      //document.getElementById(elemId).innerHTML=s;     
      func();
      },
    error: 
      function(e) { 
        document.getElementById(elemId).innerHTML= "Unable to process now. Please try later.";
      } 
  });
}

$(document).ready(function(){
 $('#search-block, #cp-block').hover(function(){
	$(this).css('cursor', 'pointer');
	$(this).click(function(){
		window.location=$(this).find("a").attr("href");
		return false;
	});
 });


  $('.read-more-link').on('click',function(){
    var $collapseDesc = $(this).siblings('.collapsableDesc');
    if( $(this).hasClass('collapse') ) {
      $(this).removeClass('collapse').addClass('expand');
      $collapseDesc.animate({
        'height': $collapseDesc[0].scrollHeight
      });
      $(this).text('Close');
    } else if( $(this).hasClass('expand') ) {
      $(this).removeClass('expand').addClass('collapse');
      $collapseDesc.animate({
        'height': '50px'
      });
      $(this).text('Read more');
    } 
  });

  $('.scrollToExcursions').click(function(e){
    e.preventDefault();
    var $target = $($(this).attr('href'));
    if( $target.length ) {
      $('html,body').animate({
            scrollTop: $target.offset().top - 75
          }, 1000);
          return false;
    }
  });

  if ($(window).width() > 768) {
    $('.read-more-link').trigger('click');
  }

  /*
   * Change Port drop down functionality changed from onchange event to
   * onclick event.
   * Added new button for click event.
   * Button click functionality.
   * $(document) reference since this page is used on the cruise detail page.
   */
  var $portlstSel = $(document).find('#portlst'),
      $portlstSelectedItem = $portlstSel.find('option').filter(':selected'),
      $portlstBtn = $(document).find('#portlst-btn'),
      currentPortId = window.location.search.substring(1).split('&')[0].split('=')[1];

  //Set button aria-label to selected port name
  $(document).find('#portlst-btn').attr('aria-label','View details about '+$portlstSelectedItem.text());
  //Button click action - submit selected port   
  $(document).off('click.portListBtn').on('click.portListBtn','#portlst-btn',function(){
    var $this = $(this),
        voyageId = $this.attr('data-voyageCode'),
        portId = $(document).find('#portlst').val(),
        bID = $this.attr('data-bId'),
        tourCode = $this.attr('data-tourCode');
    if( !$this.hasClass('deactive') ){
      submitPort(voyageId,portId,bID,tourCode);
    }    
  });
  /* On Change port */
  $(document).off('change.changePort').on('change.changePort','#portlst',function(){
    var $this = $(this),
		portName = $this.find('option').filter(':selected').text(),
        selectedPortId = $this.val().split('|')[0];
    if( currentPortId == selectedPortId ){
      $(document).find('#portlst-btn').attr('aria-label','').addClass('deactive').attr('aria-disabled',true);
    }else{
      $(document).find('#portlst-btn').attr('aria-label','Change port to '+portName).removeClass('deactive').attr('aria-disabled',false);
    }    
  });  

  /*
   * Remove cities with duplicate port-ids
   */
  $portlstSel.find('option').each(function(){
    var thisVal = $(this).val();
    if ( thisVal == 'WH1|L' || thisVal == 'YVR|L' || thisVal == 'SEA|L' ) {
      $(this).remove();
    } 
  }); 

});